import { Injectable } from '@angular/core';

import { CartValidationService } from '@app-core/validations';
import { Markup, UserResponse } from '@app-model/login';
import { AggregatorRequest, GetProductsRequest } from '@app-model/request';
import { GetProductsResponse, ProductItem, SurchargeOption } from '@app-model/response';
import { SupportedLanguageCodes } from '@app-static-data/languages';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  static productResponseDataMapper(products: ProductItem[], markup: Markup): ProductItem[] {
    return products?.map((product) => {
      // map max term to customer term property
      product.customerTerm = +product.maxTerm;

      // reset customer error
      product.errorFlag = false;
      product.errorMessage = '';

      return CartValidationService.calculateMarkup(product, markup);
    });
  }

  static aggregateProductRequestMapper(
    request: GetProductsRequest,
    languageCode: SupportedLanguageCodes
  ): AggregatorRequest {
    return new AggregatorRequest(request, languageCode);
  }

  static assignPropertiesToProducts(response: GetProductsResponse, user: UserResponse): GetProductsResponse {
    response.availableOptions.products.productItem.forEach((data) => {
      // Assigning category to each product
      if (user.productCategory) {
        data.productCategory = user.productCategory[data.productCode];
      }

      // Assigning vendor to each product if isRelatedDealer exists
      if (user.isRelatedDealer) {
        const index = user.allDealers.findIndex((dealer) => dealer.cmsDealerNumber === data.dealer);
        if (index > -1) {
          data.vendor = user.allDealers[index].vendor;
        }
      }
    });

    return response;
  }

  static addSurchargesToProducts(request: GetProductsRequest, response: GetProductsResponse): GetProductsResponse {
    const surcharges = request.surcharges;

    if (!surcharges) {
      return response;
    }

    response.availableOptions.products.productItem.forEach((product: ProductItem) => {
      product.surchargeOptions.surchargeOption.forEach((surcharge) => {
        // add flag to each surcharge that is not used
        surcharge.added = false;

        const surIndx = surcharges.findIndex((s) => s.name === surcharge.label.enUsLabel);
        if (surcharges[surIndx] && surcharges[surIndx].selected) {
          surcharge.added = true;
          product.dealerCost += +surcharge.surchargeAmount;
          product.surchargeAdded = true;
        }
      });

      // remove surcharge if not used
      product.surchargeOptions.surchargeOption = product.surchargeOptions.surchargeOption.filter((elem) => elem.added);
    });

    return response;
  }
}
